// The single source of truth for the WEB-side reference prices (EUR).
//
// The native app never shows these numbers — it renders live StoreKit prices
// or "shown at checkout" (lib/purchases.ts), because Apple charges by the
// account's storefront. But the marketing site, the web paywall and the Pro
// tab's web fallback all display them, and every surface must quote the same
// figure. Change prices HERE (and in App Store Connect); everything else —
// including the "Save N%" claims — derives.
export const PRICING = {
  currency: "EUR",
  monthly: 5.99,
  yearly: 39.99,
} as const;

/** Twelve months at the monthly rate vs one year up front. */
export function yearlySavingsPct(): number {
  return Math.round((1 - PRICING.yearly / (PRICING.monthly * 12)) * 100);
}
